import React, { useMemo, FC, ReactNode, useCallback } from "react";
import { Link as LinkReactRouterDom } from "react-router-dom";
import { scrollTop } from "src/utils/scroll";
import { ILink } from "src/@types";

interface Props extends Pick<ILink, "href" | "isOpenNewTab"> {
  children?: ReactNode;
  className?: string;
  isExternalLink?: boolean;
  isDisabled?: boolean;
  isScrollTop?: boolean;
  onClick?: VoidFunction;
}

export const Link: FC<Props> = ({
  children,
  className,
  href,
  isExternalLink,
  isOpenNewTab,
  isDisabled,
  isScrollTop = true,
  onClick,
}) => {
  const linkLabel = children || href;

  const handleClick = useCallback(() => {
    if (isScrollTop) scrollTop();
    onClick?.();
  }, [onClick, isScrollTop]);

  const link = useMemo(() => {
    if (!linkLabel) {
      return null;
    } else if (isDisabled || !href) {
      return <>{linkLabel}</>;
    } else if (isExternalLink) {
      const target = isOpenNewTab ? "_blank" : "_self";

      return (
        <a
          className={className}
          href={href}
          target={target}
          onClick={handleClick}
        >
          {linkLabel}
        </a>
      );
    } else {
      return (
        <LinkReactRouterDom
          to={href}
          className={className}
          onClick={handleClick}
        >
          {linkLabel}
        </LinkReactRouterDom>
      );
    }
  }, [
    linkLabel,
    className,
    href,
    isExternalLink,
    isOpenNewTab,
    isDisabled,
    handleClick,
  ]);

  return link;
};
